import { Typography } from "antd";
import "./styles.css";
import { useUserInfo } from "GlobalStates/User";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Features/Routes/routeConstants";
import { tierNames, tiers, tierToPaymentKey } from "Constants/index";
import { useMemo } from "react";
import { StyledButton } from "Components/StyledButton";

const { Title, Paragraph } = Typography;

export const BeginJourney = ({ showHeading = true }) => {
  const { user } = useUserInfo();
  const navigate = useNavigate();
  const nextBestPlan = useMemo(() => {
    if (!user?.token || user?.tier === tiers.STARTER) {
      return tiers.ACHIEVER;
    }
    return tiers.MENTORED;
  }, [user]);

  return (
    <div className="begin-journey-section">
      {showHeading && (
        <Title level={1} className="begin-journey-title">
          Ready to {user?.tier === tiers.STARTER ? "Begin" : "Enhance"} Your{" "}
          <br />
        <span className="begin-journey-title-highlight">
          {"Global Education Journey "}
        </span>
          ?
        </Title>
      )}
      <Paragraph className="begin-journey-subtitle">
        Join thousands of students who have found their path to academic success
        with OneGrad.
      </Paragraph>
      <div className="begin-journey-buttons">
        {!user?.token && (
          <StyledButton
            type="default"
            variant="secondary"
            className="cta-button-outline w-full md:w-1/4 text-center"
            onClick={() => navigate(ROUTES.COLLEGE_FINDER)}
          >
            Start for Free
          </StyledButton>
        )}
        {
          <StyledButton
            className="cta-button-green w-full md:w-1/4 text-center"
            onClick={() => {
              if (!user?.token) {
                navigate(
                  ROUTES.COLLEGE_FINDER_NEXT.replace(":next", ROUTES.PRICING)
                );
              } else {
                navigate(ROUTES.PAYMENT, {
                  state: {
                    paymentKey: tierToPaymentKey[nextBestPlan],
                  },
                });
              }
            }}
          >
            Get {tierNames[nextBestPlan]} Plan
          </StyledButton>
        }
      </div>
      <Paragraph className="begin-journey-note">
        No risk – use OneGrad Finance and get 100% membership refund
      </Paragraph>
    </div>
  );
};
